import React, { useEffect, useState, useRef } from "react";

import Floormapsvg from "./Floormapsvg";
import { useStoreDollHouseMap } from "../store";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import SvgElementPopup from "./SvgElementPopup";
import {
  ARIA,
  VDARA,
  BELLAGIO,
  PARK_MGM,
  THE_COSMOPOLITAN,
  NOMAD,
  DISTRICT_HIGHLIGHTS,
  TMOBILE,
  DOLBY,
} from "../scripts/core/constants";
import { Img } from "./imageComponent";
import { Box, Typography } from "@mui/material";
import { setDollhouseMap } from "./customEvents.js";
import LevelChangeTopComponent from "./LevelChangeTop";
import { shallow } from "zustand/shallow";
import Popupinfo from "./Popupinfo";
import HotspotInfoModal from "./HotspotInfoModal";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Feedback from "../layouts/Feedback";
const areaLevel = [
  { key: "area_level_1", title: "Level 1" },
  { key: "area_level_2", title: "Level 2" },
];

const cosmoLevel = [
  { key: "cosmo_level_1", title: "Level 1" },
  { key: "cosmo_level_2", title: "Level 2" },
  { key: "cosmo_level_3", title: "Level 3" },
  { key: "cosmo_level_4", title: "Level 4" },
];
// let selectedMapArea = null;
let offset = { x: 0, y: 0 };
let dollViewheight, setdollViewheight;
let setBaseMapView;
let ariaLevle = 1;
let transformComponentRef;
let dollhouseStore;
export function _changeLevel(level) {
  setBaseMapView(level);
}

export function _getCurrentAriaLevel() {
  return ariaLevle;
}

export function __setCameraZoom(value) {
  const { zoomToElement, centerView } = transformComponentRef.current;
  // console.log('aoomeddd', value)
  if (value === "Bellagio") centerView(1.1);
  if (value === "Aria1") zoomToElement("area", 1.7);
  if (value === "Aria2") zoomToElement("aria_level_2", 1.7);
  if (value === "Vdara") zoomToElement("vdara", 2.5);
  if (value === "Tcolv") zoomToElement("cosmopolitan_level_2", 1.7);
  if (value === "ParkMgm") zoomToElement("park_mgm", 1.5);
  if (value === "Nomad") zoomToElement("no_mad", 2.2);
  if (value === "DistrictHighlight") centerView(1.1);

  // zoomToElement("park_mgm_dolby_live", 1.5);
}
export default function DollhouseMapContainer({
  // updateLevelChangerLoaderVisibility,
  renderViewType,
  currentAreaSelected,
  mapRenderDatas,
  isExploreareaView,
  levelMapReset,
  dollhouseImages,
}) {
  const theme = useTheme();
  let _xs = useMediaQuery(theme.breakpoints.only("xs"));
  let _sm = useMediaQuery(theme.breakpoints.only("sm"));

  const [currentMapLevel, setCurrentMapLevel] = useState("");
  const [isLevelNeedToReset, setLevelNeedReset] = useState(false);
  [dollViewheight, setdollViewheight] = useState(window.innerHeight);
  const [hoverContent, setHoverContent] = useState(null);
  const [currentAriaLevel, setAriaLevel] = useState(1);
  const [changedLevelAriaVal, setAriaLevelVal] = useState(null);
  const [changedLevelCosmoVal, setCosmoLevelVal] = useState(null);
  const [popupshow, setPopupShow] = useState(false);
  const [startFeedback, setStartFeedBack] = useState(false);

  transformComponentRef = useRef(null);

  dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      updatePanComponentObj: state.updatePanComponentObj,
      currentCosmoPolitanLevel: state.currentCosmoPolitanLevel,
      currentAriaMapLevel: state.currentAriaMapLevel,
      currentSidebarMenuSelected: state.currentSidebarMenuSelected,
      changeCosmoPolitanLevel: state.changeCosmoPolitanLevel,
      changeAriaMapLevel: state.changeAriaMapLevel,
      isDrawerSidebarOpened: state.isDrawerSidebarOpened,
      isPopupneedToshow: state.isPopupneedToshow,
      popupmessage: state.popupmessage,
      changePopupvisibility: state.changePopupvisibility,
      isRouteSubmitted: state.isRouteSubmitted,
      sidebarmenuPoiSelected: state.sidebarmenuPoiSelected,
    }),
    shallow
  );

  useEffect(() => {
    if (levelMapReset) {
      setBaseMapView("area_level_1");
      setAriaLevelVal("area_level_1");

      setCosmoLevelVal("cosmo_level_2");
      setBaseMapView("cosmo_level_2");
    }
  }, [levelMapReset]);
  useEffect(() => {
    let url = process.env.REACT_APP_DOLLHOUSE_POPUP_API;
    let dollhouseMapHoverInformationResponse = fetch(url);

    dollhouseMapHoverInformationResponse
      .then((response) => response.json())
      .then((jsondata) => {
        setHoverContent(jsondata.popups);
      })
      .catch((error) => {
        // handle the error
      });
  }, []);

  useEffect(() => {
    if (renderViewType === "ISOMETRIC_VIEW") {
      offset.x = 0;
      offset.y = 0;
      setLevelNeedReset(true);
    } else {
      setLevelNeedReset(false);
    }
  }, [renderViewType]);

  useEffect(() => {
    if (dollhouseImages) {
      let base_img = document.querySelectorAll(".base_img");
      if (base_img.length > 0) {
        base_img[1].classList.remove("active-base-img");
        base_img[0].classList.add("active-base-img");
        base_img[3].classList.add("active-base-img");
        setCosmoLevelVal("cosmo_level_2");
      }
    }
  }, [dollhouseImages]);

  useEffect(() => {
    if (renderViewType === "ISOMETRIC_VIEW") {
      setCurrentMapLevel("");
      if (dollhouseImages) {
        let base_img = document.querySelectorAll(".base_img");
        if (base_img.length > 0) {
          base_img[0].classList.add("active-base-img");
        }
      }
    } else {
      //setActiveBaseMap(DlHse_RO_L1_wTCOLV_L2);
      // setLevelNeedReset(true);
    }
  }, [renderViewType, dollhouseImages, currentAreaSelected]);

  useEffect(() => {
    dollhouseStore.updatePanComponentObj(transformComponentRef);
  }, [dollhouseStore]);

  useEffect(() => {
    if (dollhouseImages) {
      setBaseMapView(dollhouseStore.currentCosmoPolitanLevel);
    }
  }, [dollhouseStore.currentCosmoPolitanLevel, dollhouseImages]);

  useEffect(() => {
    if (dollhouseImages) {
      setBaseMapView(dollhouseStore.currentAriaMapLevel);
    }
  }, [dollhouseStore.currentAriaMapLevel, dollhouseImages]);

  useEffect(() => {
    if (dollhouseStore.isRouteSubmitted) {
      const { centerView } = transformComponentRef.current;
      centerView(1.1);

      if (!startFeedback) {
        setStartFeedBack(true);
      }
    }
  }, [dollhouseStore.isRouteSubmitted]);

  useEffect(() => {
    const { zoomToElement, centerView } = transformComponentRef.current;

    if (dollhouseStore.isRouteSubmitted) {
      return;
    }

    // console.log("currentSidebarMenuSelected",dollhouseStore.currentSidebarMenuSelected)
    if (dollhouseStore.currentSidebarMenuSelected === "area_level_1") {
      let stva = setTimeout(() => {
        zoomToElement("area", 1.7);
        clearTimeout(stva);
      }, 0);
    }

    if (dollhouseStore.currentSidebarMenuSelected === "area_level_2") {
      let stva = setTimeout(() => {
        zoomToElement("aria_level_2", 1.7);
        clearTimeout(stva);
      }, 0);
    }

    if (dollhouseStore.currentSidebarMenuSelected === ARIA) {
      let stva = setTimeout(() => {
        if (document.getElementById("area")) {
          zoomToElement("area", 1.7);
        }

        if (document.getElementById("aria_level_2")) {
          zoomToElement("aria_level_2", 1.7);
        }

        clearTimeout(stva);
      }, 0);

      // console.log(zoomToElement);
    }

    if (dollhouseStore.currentSidebarMenuSelected === VDARA) {
      let stva = setTimeout(() => {
        zoomToElement("vdara", 2.5);
        clearTimeout(stva);
      }, 0);
    }

    if (dollhouseStore.currentSidebarMenuSelected === PARK_MGM) {
      let stva = setTimeout(() => {
        zoomToElement("park_mgm", 1.5);
        clearTimeout(stva);
      }, 0);
    }

    if (dollhouseStore.currentSidebarMenuSelected === NOMAD) {
      let stva = setTimeout(() => {
        zoomToElement("no_mad", 2.2);
        clearTimeout(stva);
      }, 0);
    }

    if (dollhouseStore.currentSidebarMenuSelected === THE_COSMOPOLITAN) {
      let stva = setTimeout(() => {
        if (_xs || _sm) {
          zoomToElement("cosmopolitan_level_2", 1.7);
        } else {
          zoomToElement("cosmopolitan_level_2", 1.8);
        }

        clearTimeout(stva);
      }, 0);
    }

    if (dollhouseStore.currentSidebarMenuSelected === BELLAGIO) {
      let stva = setTimeout(() => {
        centerView(1.1);
        clearTimeout(stva);
      }, 0);
    }

    if (dollhouseStore.currentSidebarMenuSelected === TMOBILE) {
      let stva = setTimeout(() => {
        zoomToElement("district_highlight_t_mobile", 1.8);
        clearTimeout(stva);
      }, 0);
    }

    if (dollhouseStore.currentSidebarMenuSelected === DOLBY) {
      let stva = setTimeout(() => {
        zoomToElement("park_mgm_dolby_live", 1.5);
        clearTimeout(stva);
      }, 0);
    }

    if (dollhouseStore.currentSidebarMenuSelected === DISTRICT_HIGHLIGHTS) {
      let stva = setTimeout(() => {
        centerView(1.1);
        clearTimeout(stva);
      }, 0);
    }

    if (dollhouseStore.currentSidebarMenuSelected !== "") {
      if (!startFeedback) {
        setStartFeedBack(true);
      }
    }
  }, [dollhouseStore.currentSidebarMenuSelected]);

  useEffect(() => {
    const { zoomToElement } = transformComponentRef.current;

    let stva = setTimeout(() => {
      if (document.getElementById(dollhouseStore.sidebarmenuPoiSelected)) {
        zoomToElement(dollhouseStore.sidebarmenuPoiSelected, 1.5);
        clearTimeout(stva);
      }
    }, 0);

    //zoomToSelectedELement(sidebarmenuPoiSelected , zoomToElement)
  }, [dollhouseStore.sidebarmenuPoiSelected]);

  setBaseMapView = (val) => {
    //alert(val)
    let base_img = document.querySelectorAll(".base_img");
    if (base_img.length > 0) {
      const { zoomToElement, centerView } = transformComponentRef.current;

      setCurrentMapLevel(val);
      if (val === "cosmo_level_2") {
        base_img[2].classList.remove("active-base-img");
        base_img[4].classList.remove("active-base-img");
        base_img[5].classList.remove("active-base-img");

        base_img[3].classList.add("active-base-img");
        dollhouseStore.changeCosmoPolitanLevel(val);

        setCosmoLevelVal(val);
      } else if (val === "cosmo_level_3") {
        base_img[2].classList.remove("active-base-img");
        base_img[3].classList.remove("active-base-img");
        base_img[5].classList.remove("active-base-img");

        base_img[4].classList.add("active-base-img");
        setCosmoLevelVal(val);

        dollhouseStore.changeCosmoPolitanLevel(val);
      } else if (val === "cosmo_level_1") {
        base_img[3].classList.remove("active-base-img");
        base_img[4].classList.remove("active-base-img");
        base_img[5].classList.remove("active-base-img");

        base_img[2].classList.add("active-base-img");

        setCosmoLevelVal(val);
        dollhouseStore.changeCosmoPolitanLevel(val);
      } else if (val === "cosmo_level_4") {
        base_img[2].classList.remove("active-base-img");
        base_img[3].classList.remove("active-base-img");
        base_img[4].classList.remove("active-base-img");

        base_img[5].classList.add("active-base-img");

        setCosmoLevelVal(val);

        dollhouseStore.changeCosmoPolitanLevel(val);
      } else if (val === "area_level_1") {
        base_img[1].classList.remove("active-base-img");
        base_img[0].classList.add("active-base-img");
        ariaLevle = 1;
        setAriaLevelVal(val);
        dollhouseStore.changeAriaMapLevel(val);
      } else if (val === "area_level_2") {
        setAriaLevel(2);
        base_img[0].classList.remove("active-base-img");
        base_img[1].classList.add("active-base-img");
        ariaLevle = 2;
        setAriaLevelVal(val);
        dollhouseStore.changeAriaMapLevel(val);

        setTimeout(() => {
          zoomToElement("aria_level_2", 1);
        }, 10);
      }

      setDollhouseMap(currentAreaSelected, val, hoverContent);
    }
  };

  useEffect(() => {
    function __handleResize() {
      setdollViewheight(window.innerHeight);
    }

    window.addEventListener("resize", __handleResize);
  });

  useEffect(() => {
    let mapLevel = "";
    if (currentAriaLevel === 2) {
      mapLevel = "area_level_2";
    } else {
      mapLevel = "area_level_1";
    }

    setDollhouseMap(currentAreaSelected, mapLevel, hoverContent);
  }, [currentAreaSelected, currentAriaLevel]);

  useEffect(() => {
    if (dollhouseStore.isDrawerSidebarOpened) {
      // console.log("opened", transformComponentRef);
      transformComponentRef.current.zoomOut(0.1);
    } else {
      // console.log("closed", transformComponentRef); right: 130px;
      //width: 104px;
      transformComponentRef.current.zoomIn(0.1);
    }
  }, [dollhouseStore.isDrawerSidebarOpened]);

  useEffect(() => {
    if (dollhouseStore.isPopupneedToshow) {
      setPopupShow(dollhouseStore.isPopupneedToshow);

      let cb = setTimeout(() => {
        setPopupShow(false);
        dollhouseStore.changePopupvisibility(false, "");

        clearTimeout(cb);
      }, 4000);
    }
  }, [dollhouseStore.isPopupneedToshow]);

  return (
    <>
      <Box
        className="level-header"
        sx={{
          height: "50px",
          [theme.breakpoints.down("md")]: {
            position: "absolute !important",
            right: "100px",
            width: "130px",
          },
        }}
      >
        <Box
          className="common-maker aria-marker-Level"
          sx={{ position: "relative" }}
        >
          <LevelChangeTopComponent
            setBaseMapView={setBaseMapView}
            levelList={areaLevel}
            isLevelNeedToReset={isLevelNeedToReset}
            changedLevel={changedLevelAriaVal}
            levelmap="aria"
          />
        </Box>
        <Box
          className="common-maker cosmopolitcal-marker-Level"
          sx={{ position: "relative" }}
        >
          <LevelChangeTopComponent
            setBaseMapView={setBaseMapView}
            levelList={cosmoLevel}
            isLevelNeedToReset={isLevelNeedToReset}
            changedLevel={changedLevelCosmoVal}
            levelmap="cosmo"
          />
        </Box>
      </Box>

      {startFeedback && <Feedback />}

      {hoverContent && <HotspotInfoModal hoverContent={hoverContent} />}
      {popupshow && (
        <Popupinfo message={dollhouseStore.popupmessage} type="warning" />
      )}

      <TransformWrapper ref={transformComponentRef} wheel={false}>
        <TransformComponent>
          <Floormapsvg
            renderViewType={renderViewType}
            isExploreareaView={isExploreareaView}
            mapRenderDatas={mapRenderDatas}
            dollhouseImages={dollhouseImages}
            transformComponentRef={transformComponentRef}
          />
        </TransformComponent>
      </TransformWrapper>
    </>
  );
}

/**
 * 
  function __widthtoPixcel(width, percentagewidth) {
    return (width * (percentagewidth / 100));
  }

  function __heightoPixcel(height, percentageHeight) {
    return (height * (percentageHeight / 100));
}
 */
